import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("c4b_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("c4b_token");
      localStorage.removeItem("c4b_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const endpoints = {
  login: (body) => api.post("/auth/login", body).then((r) => r.data),
  setupInfo: (token) => api.get(`/auth/setup/${token}`).then((r) => r.data),
  setPassword: (body) => api.post("/auth/set-password", body).then((r) => r.data),
  listUsers: () => api.get("/users").then((r) => r.data),
  createUser: (body) => api.post("/users", body).then((r) => r.data),
  editUser: (email, body) => api.put(`/users/${encodeURIComponent(email)}`, body).then((r) => r.data),
  resetUser: (email) => api.post(`/users/${encodeURIComponent(email)}/reset`).then((r) => r.data),
  deleteUser: (email) => api.delete(`/users/${encodeURIComponent(email)}`).then((r) => r.data),
  getConnection: () => api.get("/connection").then((r) => r.data),
  saveConnection: (body) => api.put("/connection", body).then((r) => r.data),
  testConnection: () => api.post("/connection/test").then((r) => r.data),
  diagnoseInvoices: () => api.post("/connection/diagnose-invoices").then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  meta: () => api.get("/meta").then((r) => r.data),
  leakboard: (track = "all") =>
    api.get(`/leakboard?track=${track}`).then((r) => r.data),
  accounts: (params = {}) =>
    api.get("/accounts", { params }).then((r) => r.data),
  account: (id) => api.get(`/accounts/${id}`).then((r) => r.data),
  sites: (params = {}) => api.get("/sites", { params }).then((r) => r.data),
  site: (sid) => api.get(`/sites/${encodeURIComponent(sid)}`).then((r) => r.data),
  setInternalAccount: (id, internalAccount) => api.put(`/accounts/${id}/internal`, { internalAccount }).then((r) => r.data),
  accountSettings: (id) => api.get(`/accounts/${id}/settings`).then((r) => r.data),
  saveAccountSettings: (id, body) => api.put(`/accounts/${id}/settings`, body).then((r) => r.data),
  siteSettings: (id, sid) => api.get(`/accounts/${id}/sites/${sid}/settings`).then((r) => r.data),
  // committedKgPerPeriod null CLEARS the site's commitment (see put_site_settings).
  saveSiteSettings: (id, sid, body) => api.put(`/accounts/${id}/sites/${sid}/settings`, body).then((r) => r.data),
  dismissSignal: (sid, body) => api.post(`/signals/${sid}/dismiss`, body).then((r) => r.data),
  snapshot: (id) => api.get(`/snapshot/${id}`).then((r) => r.data),
  snapshotSearch: (q) =>
    api.get(`/snapshot/search?q=${encodeURIComponent(q)}`).then((r) => r.data),
  settings: () => api.get("/settings").then((r) => r.data),
  saveSettings: (body) => api.put("/settings", body).then((r) => r.data),
  resetSettings: () => api.post("/settings/reset").then((r) => r.data),
  setDemoMode: (demoMode) => api.put("/settings/demo-mode", { demoMode }).then((r) => r.data),
  health: () => api.get("/health/data").then((r) => r.data),
  catalog: (onlyIssues = false) => api.get(`/catalog?onlyIssues=${onlyIssues}`).then((r) => r.data),
  saveCatalog: (id, body) => api.put(`/catalog/${encodeURIComponent(id)}`, body).then((r) => r.data),
  syncNow: () => api.post("/sync/run").then((r) => r.data),
  syncStart: (scope, confirmPurge = false, force = false) => api.post("/sync/start", { scope, confirmPurge, force }).then((r) => r.data),
  syncProgress: () => api.get("/sync/progress").then((r) => r.data),
  syncCancel: () => api.post("/sync/cancel").then((r) => r.data),
  syncClearStuck: () => api.post("/sync/clear-stuck").then((r) => r.data),
  syncResume: () => api.post("/sync/resume").then((r) => r.data),
  syncLog: () => api.get("/sync/log").then((r) => r.data),
  dismiss: (sid, body) =>
    api.post(`/signals/${sid}/dismiss`, body).then((r) => r.data),
  logAction: (cid, body) =>
    api.post(`/accounts/${cid}/action`, body).then((r) => r.data),
};
